// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern DeepL-inspired design */
:root {
  /* Color Palette - modern, elegant with DeepL vibes */
  --primary-color: #0f2b46;
  --secondary-color: #5a6b7d;
  --accent-color: #0047AB;
  --accent-hover: #003580;
  --background-color: #ffffff;
  --surface-color: #f9fafb;
  --border-color: #e5e7eb;
  --border-hover: #cbd5e1;
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  /* Spacing - geometric, consistent */
  --spacing-xs: 0.5rem;
  --spacing-sm: 1rem;
  --spacing-md: 1.5rem;
  --spacing-lg: 2rem;
  --spacing-xl: 3rem;

  /* Typography */
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.5rem;
  --font-size-2xl: 2rem;

  /* Borders */
  --border-radius: 12px;
  --border-radius-lg: 16px;
  --border-width: 1px;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Clean, minimal button styles */
button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  background: none;
  transition: all 0.2s ease;
}

button:focus {
  outline: 2px solid var(--accent-color);
  outline-offset: 2px;
}

/* Input base styles */
input,
textarea,
select {
  font-family: inherit;
  font-size: var(--font-size-base);
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius);
  transition: border-color 0.2s ease;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: var(--accent-color);
}

/* Utility classes */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

.text-muted {
  color: var(--text-muted);
}

.text-secondary {
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,qDAAqD;EACrD,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;;EAEtF,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;;EAElB,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;;EAErB,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;;;EAGE,oBAAoB;EACpB,gCAAgC;EAChC,qDAAqD;EACrD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["/* Modern DeepL-inspired design */\n:root {\n  /* Color Palette - modern, elegant with DeepL vibes */\n  --primary-color: #0f2b46;\n  --secondary-color: #5a6b7d;\n  --accent-color: #0047AB;\n  --accent-hover: #003580;\n  --background-color: #ffffff;\n  --surface-color: #f9fafb;\n  --border-color: #e5e7eb;\n  --border-hover: #cbd5e1;\n  --text-primary: #1f2937;\n  --text-secondary: #6b7280;\n  --text-muted: #9ca3af;\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\n  /* Spacing - geometric, consistent */\n  --spacing-xs: 0.5rem;\n  --spacing-sm: 1rem;\n  --spacing-md: 1.5rem;\n  --spacing-lg: 2rem;\n  --spacing-xl: 3rem;\n\n  /* Typography */\n  --font-size-sm: 0.875rem;\n  --font-size-base: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.5rem;\n  --font-size-2xl: 2rem;\n\n  /* Borders */\n  --border-radius: 12px;\n  --border-radius-lg: 16px;\n  --border-width: 1px;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Clean, minimal button styles */\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  background: none;\n  transition: all 0.2s ease;\n}\n\nbutton:focus {\n  outline: 2px solid var(--accent-color);\n  outline-offset: 2px;\n}\n\n/* Input base styles */\ninput,\ntextarea,\nselect {\n  font-family: inherit;\n  font-size: var(--font-size-base);\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius);\n  transition: border-color 0.2s ease;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n  border-color: var(--accent-color);\n}\n\n/* Utility classes */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 var(--spacing-md);\n}\n\n.text-muted {\n  color: var(--text-muted);\n}\n\n.text-secondary {\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
